// extracted by mini-css-extract-plugin
export default {"container":"OverDivComponent_container__gDgGN","sub_container":"OverDivComponent_sub_container__Nus1+","info_container":"OverDivComponent_info_container__4IBOz"};